import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import AllergyForm from './AllergyForm';

const AllergyModal = ({ show, onHide, allergyvalue, edittrigger, onCallParent }) => {
    const isEdit = allergyvalue && (allergyvalue.allergy_id || allergyvalue.id);

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Allergy' : 'Add Allergy'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <AllergyForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    allergyvalue={allergyvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

AllergyModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    allergyvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default AllergyModal;

